import { Input, Spin } from "antd";
import type { ChangeEvent, FC } from "react";
import { useCallback } from "react";

import { ResourceName } from "../../../../core/router/config/ResourceName";
import { SecondaryButton } from "../../../Buttons/components/ActionButton";
import { IconCodes } from "../../../Icon/IconCodes";
import { Icon } from "../../../index";
import { useLazyLoadConfigValueQuery } from "../../services/server/formComponentsApi";
import type { AntCustomFormField } from "../../types/types";
import { buttonStyle, inputStyle } from "../SiteIdGenerator/buttonGeneratorStyle";

export interface InputGeneratorProps extends AntCustomFormField<string> {
    label: string;
    readOnly: boolean;
    name: string;
    orgUnitId: number;
    terminalId: number;
}

export const TerminalIdCopyGenerator: FC<InputGeneratorProps> = ({ orgUnitId, terminalId, readOnly, onChange, ...restProps }) => {
    const onValueChange = (ev: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(ev.target.value);
        }
    };

    const [data, { isFetching }] = useLazyLoadConfigValueQuery();

    const onClick = useCallback(() => {
        if (onChange) {
            const urlToFetchOptions = `/${ResourceName.TERMINAL_COPY_ID_GENERATOR}?orgUnitId=${orgUnitId}&terminalId=${terminalId}`;
            data(urlToFetchOptions)
                .unwrap()
                .then((response) => {
                    if (response.value) {
                        onChange(response.value);
                    }
                });
        }
    }, [orgUnitId, terminalId, data, onChange]);

    return (
        <Spin spinning={isFetching}>
            <Input.Group compact>
                <Input readOnly={readOnly || isFetching} onChange={onValueChange} style={inputStyle} {...restProps} />
                <SecondaryButton
                    name="terminalIdGenerator_button"
                    onClick={onClick}
                    disabled={readOnly || isFetching}
                    icon={<Icon iconName={IconCodes.RedoOutlined} />}
                    style={buttonStyle}
                />
            </Input.Group>
        </Spin>
    );
};
